import {
	HttpEvent,
	HttpHandlerFn,
	HttpParams,
	HttpRequest,
} from '@angular/common/http';

import { Observable } from 'rxjs';

const replaceTcd = (value: string): string => {
	return value.replace(/TCD/g, 'USD');
};

function isPlainObject(
	value: unknown
): value is Record<string, unknown> {
	if (
		value === null ||
		typeof value !== 'object'
	) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);

	return (
		prototype === Object.prototype ||
		prototype === null
	);
}

function replaceTcdDeep(value: unknown): unknown {
	// null / undefined
	if (value == null) {
		return value;
	}

	// string
	if (typeof value === 'string') {
		return replaceTcd(value);
	}

	// FormData
	if (value instanceof FormData) {
		return replaceTcdInFormData(value);
	}

	// File
	if (typeof File !== 'undefined' && value instanceof File) {
		return value;
	}

	// Blob
	if (typeof Blob !== 'undefined' && value instanceof Blob) {
		return value;
	}

	// Date
	if (value instanceof Date) {
		return value;
	}

	// Array
	if (Array.isArray(value)) {
		return value.map(item => replaceTcdDeep(item));
	}

	// Plain Object
	if (isPlainObject(value)) {
		const result: Record<string, unknown> = {};

		Object.keys(value).forEach(key => {
			result[key] = replaceTcdDeep(value[key]);
		});

		return result;
	}

	// number / boolean / special objects
	return value;
}

function replaceTcdInFormData(
	formData: FormData
): FormData {
	const newFormData = new FormData();

	formData.forEach((value, key) => {
		// String field
		if (typeof value === 'string') {
			newFormData.append(
				key,
				replaceTcd(value)
			);

			return;
		}

		// File
		if (
			typeof File !== 'undefined' &&
			value instanceof File
		) {
			newFormData.append(
				key,
				value,
				value.name
			);

			return;
		}

		// Blob
		newFormData.append(key, value);
	});

	return newFormData;
}

function replaceTcdInParams(
	params: HttpParams
): HttpParams {
	let newParams = new HttpParams();

	params.keys().forEach(key => {
		const values = params.getAll(key);

		if (!values) {
			return;
		}

		values.forEach(value => {
			// هم key و هم value را بررسی می‌کنیم
			newParams = newParams.append(
				replaceTcd(key),
				replaceTcd(value)
			);
		});
	});

	return newParams;
}

export function replaceTcdInterceptor(
	req: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {

	const modifiedRequest = req.clone({
		// URL Path
		url: replaceTcd(req.url),

		// Query Params
		params: replaceTcdInParams(req.params),

		// Body / JSON / FormData
		body: replaceTcdDeep(req.body),
	});

	return next(modifiedRequest);
}